// extracted by mini-css-extract-plugin
export default {"loadingPlaceholder":"GlobalSearch_loadingPlaceholder__ypwrL","shimmer":"GlobalSearch_shimmer__k-KQu","dark":"GlobalSearch_dark__V43eZ"};